module.exports = __webpack_public_path__ + "img/11.bdd88a1f.png";